import { render, staticRenderFns } from "./PleatinglistdetailsPage.vue?vue&type=template&id=579ac0cc"
import script from "./PleatinglistdetailsPage.vue?vue&type=script&lang=js"
export * from "./PleatinglistdetailsPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports